<ng-content></ng-content>
<div *ngIf="renderComponentInvalid" class="is-invalid"></div>
<ng-template
    ngFor
    let-itemError
    [ngForTrackBy]="trackByFnErrors"
    [ngForOf]="getControlErrors()"
>
    <div class="feedback invalid-feedback">
        <span [ngSwitch]="itemError?.error">
            <ng-container
                *ngSwitchCase="'minlength'"
                [ngTemplateOutlet]="minLengthError"
                [ngTemplateOutletContext]="{
                    $implicit: itemError
                }"
            ></ng-container>
            <ng-container
                *ngSwitchCase="'matchedValues'"
                [ngTemplateOutlet]="matchedValuesError"
                [ngTemplateOutletContext]="{
                    $implicit: itemError
                }"
            ></ng-container>
            <ng-container
                *ngSwitchCase="'mismatched'"
                [ngTemplateOutlet]="mismatchedValuesError"
                [ngTemplateOutletContext]="{
                    $implicit: itemError
                }"
            ></ng-container>
            <ng-container
                *ngSwitchCase="'matched'"
                [ngTemplateOutlet]="matchedError"
                [ngTemplateOutletContext]="{
                    $implicit: itemError
                }"
            ></ng-container>
            <ng-container
                *ngSwitchCase="'differenceDatesOut'"
                [ngTemplateOutlet]="differenceDatesOutError"
                [ngTemplateOutletContext]="{
                    $implicit: itemError
                }"
            ></ng-container>
            <ng-container
                *ngSwitchCase="'differenceDatesIn'"
                [ngTemplateOutlet]="differenceDatesInError"
                [ngTemplateOutletContext]="{
                    $implicit: itemError
                }"
            ></ng-container>
            <ng-container
                *ngSwitchDefault
                [ngTemplateOutlet]="genericError"
                [ngTemplateOutletContext]="{
                    $implicit: itemError
                }"
            ></ng-container>
        </span>
    </div>
</ng-template>
<ng-template #genericError let-itemError>
    {{ 'fe_' + flowPage + '_input_' + itemError?.error | translate }}
</ng-template>
<ng-template #minLengthError let-itemError>
    {{
        'fe_' + flowPage + '_input_' + itemError?.error
            | translate
            | replace
                : {
                      actualLength: itemError?.reason?.actualLength,
                      requiredLength: itemError?.reason?.requiredLength
                  }
    }}
</ng-template>
<ng-template #matchedValuesError let-itemError>
    {{
        'fe_' + flowPage + '_input_' + itemError?.error
            | translate
            | replace
                : {
                      currentValue: itemError?.reason?.currentValue,
                      toMistmachValue: itemError?.reason?.toMistmachValue
                  }
    }}
</ng-template>
<ng-template #mismatchedValuesError let-itemError>
    {{
        'fe_' + flowPage + '_input_' + itemError?.error
            | translate
            | replace
                : {
                      currentControl: itemError?.reason?.currentControl,
                      currentValue: itemError?.reason?.currentValue,
                      toMatchControl: itemError?.reason?.toMatchControl,
                      toMatchValue: itemError?.reason?.toMatchValue
                  }
    }}
</ng-template>
<ng-template #matchedError let-itemError>
    {{
        'fe_' + flowPage + '_input_' + itemError?.error
            | translate
            | replace
                : {
                      currentControl: itemError?.reason?.currentControl,
                      currentValue: itemError?.reason?.currentValue,
                      toMismatchControl: itemError?.reason?.toMismatchControl,
                      toMismatchValue: itemError?.reason?.toMismatchValue
                  }
    }}
</ng-template>
<ng-template #differenceDatesOutError let-itemError>
    {{
        'fe_' + flowPage + '_input_' + itemError?.error
            | translate
            | replace
                : {
                      currentControl: itemError?.reason?.currentControl,
                      toMaxControl: itemError?.reason?.toMaxControl,
                      units: itemError?.reason?.units,
                      durationUnits: itemError?.reason?.durationUnits,
                      toMaxDifference: itemError?.reason?.toMaxDifference
                  }
    }}
</ng-template>
<ng-template #differenceDatesInError let-itemError>
    {{
        'fe_' + flowPage + '_input_' + itemError?.error
            | translate
            | replace
                : {
                      currentControl: itemError?.reason?.currentControl,
                      toMinControl: itemError?.reason?.toMinControl,
                      units: itemError?.reason?.units,
                      durationUnits: itemError?.reason?.durationUnits,
                      toMinDifference: itemError?.reason?.toMinDifference
                  }
    }}
</ng-template>
